import { LevelType, TabType } from "interfaces/common.interface";

export const REPORT_TABS: { [key: string]: TabType } = {
  credit_inissuance: "credit_issuance",
  credit_redemption: "credit_redemption",
  user_level_summary: "user_level_summary",
  username_change: "username_change",
};

export const REPORT_TABS_BY_LEVEL: Record<LevelType, TabType[]> = {
  credit_level: ["credit_issuance", "credit_redemption"],
  user_level: ["user_level_summary", "username_change"],
};

export const TAB_LABELS: Record<TabType, string> = {
  credit_issuance: "Credit Issuance Report",
  credit_redemption: "Credit Redemption Report",
  user_level_summary: "User Summary Report",
  username_change: "Username Change Report",
};

export const getLevelForTab = (tab: TabType): LevelType => {
  if (REPORT_TABS_BY_LEVEL.credit_level.includes(tab)) {
    return "credit_level";
  }
  return "user_level";
};

export const isValidTabType = (value: string | null): value is TabType => {
  const validTabs: TabType[] = [
    "credit_issuance",
    "credit_redemption",
    "user_level_summary",
    "username_change",
  ];
  return validTabs.includes(value as TabType);
};
